<script setup>
import WrTechnologiesFrameworkSimilarHeroSection from "~/components/global/WrTechnologiesFrameworkSimilarHeroSection.vue";
import { useGlobalStore } from "~/stores/globalStore";
import WrVideoHeroSection from "~/components/global/WrVideoHeroSection.vue";
import ServiceValueCard from "~/components/global/ServiceValueCard.vue";
import WrImageAndCardSection from "~/components/global/WrImageAndCardSection.vue";
const globalStore = useGlobalStore();

const data = await import(
  "../../../public/content/services/frameworks/adonisjs-development-services-content.json"
);

useHead({
  title: data?.meta_tags.title || "",
  meta: data?.meta_tags.meta || [],
  link: [{ rel: "preload", as: "image", href: data?.header.image }],
});

const projects = ref([
  {
    id: "01",
    title: "Real time",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "02",
    title: "Order Management",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "03",
    title: "Analytic",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "04",
    title: "Leaning Management System",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "05",
    title: "Live Streaming",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
]);
const visible = ref(false);

const formPrefilledData = ref(null);

const openModal = (prefilledValue = null) => {
  if (prefilledValue == null) formPrefilledData.value = null;
  else if (prefilledValue.length) formPrefilledData.value = prefilledValue;
  visible.value = true;
};
</script>

<template>
  <section class="dark:bg-none pb-10 lg:pb-20">
    <div class="container-wrapper-xl">
      <WrTechnologiesFrameworkSimilarHeroSection :data="data?.header" @open-modal="openModal" />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <WrVideoHeroSection :data="data?.our_promises" />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <h2 class="lg:text-center">
        <WrGradientText>
          {{ data?.expertise?.heading }}
        </WrGradientText>
      </h2>
      <p class="max-w-screen-lg mx-auto lg:text-center text-xl tracking-[0.5px]">
        {{ data?.expertise?.subheading }}
      </p>

      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-20 mt-12">
        <div v-for="service in data?.expertise?.expertisetext">
          <ServiceValueCard :img="service?.image" :title="service?.heading" :description="service?.text" />
        </div>
      </div>
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <WrCardCTA append-class="max-md:px-4 py-8" :description="data?.project_in_mind?.subheading"
        :icon="data?.project_in_mind?.image" :title="data?.project_in_mind?.heading"
        :subtitle="data?.project_in_mind?.small_heading" :button-text="data?.project_in_mind?.linkText" />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <h2 class="lg:text-center">
        <WrGradientText>
          {{ data?.framework_benefits?.heading }}
        </WrGradientText>
      </h2>
      <p class="max-w-screen-lg mx-auto lg:text-center text-xl tracking-[0.5px]">
        {{ data?.framework_benefits?.subheading }}
      </p>

      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-20 mt-12">
        <div v-for="service in data?.framework_benefits?.benefit_items">
          <ServiceValueCard :img="service?.image" :title="service?.title" :description="service?.text" />
        </div>
      </div>
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <WrImageAndCardSection :data="data?.partnering" />
      <WrGoogleRating />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl flex max-lg:flex-col justify-between items-center gap-14 lg:gap-32 lg:*:w-1/2">
      <div>
        <h2 class="text-3xl lg:text-4xl mb-2 max-md:mb-4 md:mb-4">
          <WrGradientText :text="data?.contact_us_bar2?.heading"
            append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]" />
        </h2>
        <p class="text-base lg:text-lg xl:text-xl leading-relaxed tracking-wider">
          {{ data?.contact_us_bar2?.subheading }}
        </p>
      </div>
      <WrCardCTA append-class="lg:py-14 lg:mr-8" :icon="data?.contact_us_bar2?.box?.image" alt="Development Services"
        :subtitle="data?.contact_us_bar2?.box?.small_heading" :title="data?.contact_us_bar2?.box?.heading"
        :description="data?.contact_us_bar2?.box?.subheading" buttonText="Let's Connect" />
    </div>
  </section>

  <!-- Faq Section -->
  <section>
    <div class="max-w-screen-xl mx-auto px-4 w-full grid md:grid-cols-2 gap-6 relative z-10 pb-10 lg:pb-24 mt-20">
      <div class="max-md:text-center mx-auto max-w-[504px] z-10 relative">
        <h3>
          <WrGradientText text="Get all your questions" append-class="py-0 md:py-4" />
          <span>answered here</span>
        </h3>
        <p class="mt-5 pr-4 text-lg tracking-[0.5px]">
          {{ data?.faq?.subheading }}
        </p>
      </div>
      <div class="grow">
        <WrAccordion :Content="data?.faq?.collapses" />
      </div>
    </div>
  </section>


  <!-- Seleted Project Section -->

 <section class="section-spacing dark:bg-none relative z-10 overflow-visible  order-9">
    <div class="container-wrapper-lg w-full relative">
      <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>

      <WrSelectedProject />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl flex max-lg:flex-col gap-14">
      <div class="lg:w-[45%]">
        <h2 class="text-3xl lg:text-4xl mb-2 max-md:mb-4 md:mb-4">
          <WrGradientText :text="data?.hire_us?.heading"
            append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]" />
        </h2>
        <p class="text-base lg:text-lg xl:text-xl leading-relaxed tracking-wider">
          {{ data?.hire_us?.subheading }}
        </p>
      </div>
      <div class="grid sm:grid-cols-2 gap-4">
        <!-- Hourly Basis -->
        <WrCardHiring
          @openModal="openModal"
          v-for="(card, index) in data?.hire_us?.cards"
          :title="card?.type"
          :description="card?.billing"
          :badgeText="card?.duration"
          :offerText="card?.offerText"
          :icon="card?.image"
          :showCounter="card?.showCounter"
          :defaultCount="parseInt(parseInt(card?.defaultCount))"
          :buttonLabel="card?.buttonLabel"
          :page="{ name: 'Adonis JS' }"
          :index="index"
        />
      </div>
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <h2 class="lg:text-center">
        <WrGradientText append-class=" leading-[1.2]">
          {{ data?.other_services?.side_box?.heading }}
        </WrGradientText>
      </h2>
      <p class="max-w-screen-lg mx-auto lg:text-lg lg:text-center tracking-[0.5px] mb-5 mt-2">
        {{ data?.other_services?.side_box?.subheading }}
      </p>
      <WrFrameworksCarousel />
    </div>
  </section>

  <section class="dark:bg-none section-spacing">
    <div class="container-wrapper-xl">
      <h2 class="lg:text-center">
        <WrGradientText append-class="leading-[1.5]">
          {{ data?.call_to_action?.heading }}
        </WrGradientText>
      </h2>
      <p class="max-w-screen-lg mx-auto lg:text-lg lg:text-center tracking-[0.5px] mb-5 mt-2">
        {{ data?.call_to_action?.subheading }}
      </p>

      <div class="grid sm:grid-cols-2 gap-14 lg:gap-44 lg:px-12 mt-12">
        <WrCardCTA v-for="card in data?.call_to_action?.boxes" img-position="left"
          append-class="pt-36 max-lg:pb-8 lg:py-14 lg:pl-20 pr-8" :icon="card.image" alt="Development Services"
          :subtitle="card?.small_heading" :title="card?.heading" :description="card?.subheading"
          :buttonText="card?.linkText" :icon-append-class="card?.iconAppend" />
      </div>
    </div>
  </section>

  <section>
      <div class="max-w-screen-xl mx-auto py-10 lg:pb-24">
        <h2 class="text-center px-4">
          <WrGradientText text="Trusted for excellence and efficiency" />
        </h2>
        <p
          class="px-4 text-lg text-[var(--foreground)] mb-10 text-center tracking-[0.5px]"
        >
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
        <!-- Carousel Section -->

        <WrTestimonialCardCarousel />

        <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-2"
          >View All</WrButton
        >
      </div>
    </section>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" :prefilledContent="formPrefilledData" />
</template>
